export const library = (state) => {
  return state.library;
};

export const playlistMedia = (state) => {
  return state.playlistMedia;
};

export const media = (state) => {
  return state.media;
};

export const uploadingMediaList = (state) => {
  return state.uploadingMediaList;
};

export const uploadProcessing = (state) => {
  return state.uploadProcessing;
};

export const uploadingCompleted = (state) => {
  if (!state.uploadingMediaList.length) {
    return false;
  }

  return (
    state.uploadingMediaList.filter((media) => {
      return media.status !== "error" && media.progress !== 100;
    }).length === 0
  );
};

export const uploadingCompletedCount = (state) => {
  return state.uploadingMediaList.filter(
    (media) => media.status === "success" || media.status === "error"
  ).length;
};

export const uploadingProgress = (state, getters) => {
  return (
    (getters.uploadingCompletedCount / state.uploadingMediaList.length) * 100
  );
};
